const pseudoDescriptors = {
  hoverStyle: {
    name: "hover",
    priority: 1
  },
  pressStyle: {
    name: "active",
    stateKey: "press",
    priority: 2
  },
  focusStyle: {
    name: "focus",
    priority: 3
  },
  enterStyle: {
    name: "enter",
    stateKey: "unmounted",
    priority: 4
  },
  exitStyle: {
    name: "exit",
    stateKey: "isExiting",
    priority: 5
  }
};
export {
  pseudoDescriptors
};
//# sourceMappingURL=pseudoDescriptors.js.map
